<template>
  <div class="form-group position-relative">
    <label v-if="label" class="font-size-12">{{ label }}</label>
    <div class="input-container d-flex">
      <input v-model="iValue" type="text" class="form-control" placeholder="https://example.com" :style="{ flex: '1 1 auto' }" />
      <button class="btn-upload" title="Upload" @click="selectFile">
        <b-spinner v-if="loadingUpload" small />
        <i v-else :class="uploadIcon" />
      </button>
      <button v-if="splashImage" class="btn-upload" title="Images" @click="showImagesModal">
        <i :class="imagesIcon" />
      </button>
      <button class="btn-upload btn-remove" title="Delete" @click="removeImage">
        <i :class="deleteIcon" />
      </button>
      <input ref="inputFile" type="file" name="upload" :style="{ display: 'none' }" accept="image/*" @change="uploadFile($event)" />
    </div>
    <div ref="splashImages" class="splash-images" :style="{ display: 'none' }">
      <div class="input-container d-flex">
        <input v-model="query" type="text" class="form-control" placeholder="Search..." :style="{ flex: '1 1 auto' }" @keyup.enter="searchImages" />
        <button class="btn-upload" title="Images" :disabled="!query" @click="searchImages">
          <b-spinner v-show="loadingImages" small />
          <i v-show="!loadingImages" :class="magnifyingIcon" />
        </button>
      </div>
      <div class="list-images">
        <img v-for="(img, index) in splashImages" :key="index" :src="img.urls.regular" @click="selectImage(img)" />
      </div>
      <div v-if="splashImages.length" class="text-center mt-3">
        <b-button variant="outline-primary" size="sm" @click="loadMoreImages">
          <b-spinner v-show="loadingMoreImages" small />
          <span v-show="!loadingMoreImages">More images</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import './Styles/ImageInput2.scss'
import { DELETE_ICON, IMAGES_ICON, MAGNIFYING_ICON, UPLOAD_ICON } from '@src/icons'
export default {
  props: {
    value: { required: false, type: [String], default: '' },
    label: { type: [String], default: '' },
    splashImage: { type: [Boolean], default: true },
    resize: { type: Boolean, default: false }
  },
  data() {
    return {
      deleteIcon: DELETE_ICON,
      imagesIcon: IMAGES_ICON,
      uploadIcon: UPLOAD_ICON,
      magnifyingIcon: MAGNIFYING_ICON,
      loadingUpload: false,
      loadingImages: false,
      loadingMoreImages: false,
      splashImages: [],
      query: '',
      page: 1,
      timer: null
    }
  },
  computed: {
    iValue: {
      get() { return this.value },
      set(newVal) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          let that = this
          let img = new Image()
          img.onload = function() {
            let ratio = 0
            if (this.width && this.height && !isNaN(this.width) && !isNaN(this.height) && parseFloat(this.width) > 0) {
              const width = parseFloat(this.width)
              const height = parseFloat(this.height)
              ratio = parseFloat(parseFloat(height / width).toFixed(2))
            }
            that.$emit('return-data', { Ratio: ratio })
          }
          img.src = newVal
        }, 500)
        this.$emit('input', newVal)
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.toggleSplashImages)
  },
  methods: {
    selectFile() { this.$refs.inputFile.click() },
    uploadFile(event) {
      if (!event.target.files.length) return
      let imageParams = new FormData()
      imageParams.append('file', event.target.files[0])
      imageParams.append('resize-image', this.resize)
      this.loadingUpload = true
      this.$store
        .dispatch('image/uploadImage', imageParams)
        .then((response) => {
          this.$emit('input', response.url)
          this.$emit('return-data', response)
          this.loadingUpload = false
        })
        .catch(() => this.loadingUpload = false)
    },
    loadMoreImages() {
      this.page += 1
      this.loadingMoreImages = true
      this.$store
        .dispatch('image/getUnsplashImages', { query: this.query, page: this.page })
        .then((images) => {
          this.splashImages = [ ...this.splashImages, ...images ]
          this.loadingMoreImages = false
        })
        .catch(() => this.loadingMoreImages = false)
    },
    searchImages() {
      this.page = 1
      this.getImages()
    },
    getImages() {
      this.loadingImages = true
      this.$store
        .dispatch('image/getUnsplashImages', { query: this.query, page: this.page })
        .then((images) => {
          this.splashImages = images
          this.loadingImages = false
          if (this.$refs.splashImages) this.$refs.splashImages.style.display = 'block'
        })
        .catch(() => this.loadingImages = false)
    },
    selectImage(img) {
      let Ratio = 0
      if (img.width && img.height) {
        Ratio = parseFloat(img.height / img.width)
        Ratio = parseFloat(Ratio.toFixed(2))
      }
      this.$emit('input', img.urls.regular)
      this.$emit('return-data', { Ratio })
    },
    toggleSplashImages(event) {
      let $el = event.target
      let clickOutSide = true
      do {
        if ($el && $el.className === 'splash-images') {
          clickOutSide = false
          break
        }
        $el = $el.parentNode
      } while ($el)
      if (clickOutSide) {
        if (this.$refs.splashImages) this.$refs.splashImages.style.display = 'none'
        document.removeEventListener('click', this.toggleSplashImages)
      }
    },
    removeImage() { this.$emit('input', null) },
    showImagesModal(event) {
      event.stopPropagation()
      document.addEventListener('click', this.toggleSplashImages)
      if (!this.splashImages.length) this.getImages()
      if (this.$refs.splashImages) this.$refs.splashImages.style.display = 'block'
    }
  }
}
</script>